import { render } from "preact";
import { App } from "./App";
import { loadInitialPuzzle } from "./game/state";
import { bootRouteForPath } from "./main-route";
import "./styles/index.css";

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root");

// Boot order: dev install → puzzle load → first render. The dev
// install registers the dev-mode-aware puzzle loader on the state
// machine BEFORE loadInitialPuzzle runs, so dev-mode panels get
// to override the live-API path on the very first call. In
// production builds, `import.meta.env.DEV` folds to the literal
// `false`, the surrounding branch becomes dead code, and the
// dynamic import target is unreachable to the bundler — exactly
// the contract in briefs/dev-mode.md §"Gate pattern".
async function boot(): Promise<void> {
  if (import.meta.env.DEV) {
    const m = await import("./dev/install");
    const outcome = await m.installDevMode();
    // A dev-only page (the /match prototype, /score-harness, or
    // /juice-harness) owns #app when it activates — skip the
    // daily-game's puzzle load and main App render entirely.
    if (outcome != null) return;
  }
  const route = bootRouteForPath(window.location.pathname, import.meta.env.DEV);
  if (route === "match-preview") {
    const m = await import("./match/install");
    m.installMatchPreview(root!);
    return;
  }
  await loadInitialPuzzle();
  render(<App />, root!);
}

void boot();
